import { EXPAND_COLUMN } from "./constant";
import { FooterComponents as Summary } from "./Footer";
import Column from "./sugar/Column";
import ColumnGroup from "./sugar/ColumnGroup";
import Table, { genTable } from "./Table";
import { INTERNAL_COL_DEFINE } from "./utils/legacyUtil";
export { genTable, Summary, Column, ColumnGroup, INTERNAL_COL_DEFINE, EXPAND_COLUMN };
export default Table;